import { apiCall } from "./imports"

export default {
    login(data) {
        return apiCall('post', "/management/auth/login", data)
    },
    getCsrf() {
        return apiCall('get', "/sanctum/csrf-cookie")
    }
}